module.exports = __webpack_public_path__ + "img/cns_android13.ef64c707.png";